import {
  FormControl,
  OutlinedInput,
  FormHelperText,
  InputBaseProps,
  TextFieldProps,
} from '@mui/material'
import { useTheme } from '@mui/material/styles'
import { KFieldLabel } from 'components/core/KFieldLabel'
import { isEmpty } from 'lodash'
import { ForwardRefExoticComponent, RefAttributes, forwardRef } from 'react'

export interface KTextFieldProps
  extends Omit<TextFieldProps, 'variant'>,
    Pick<
      InputBaseProps,
      'endAdornment' | 'startAdornment' | 'onChange' | 'onFocus'
    > {
  labelSize?: 'small' | 'medium' | 'large'
}

export const KTextField: ForwardRefExoticComponent<
  Omit<KTextFieldProps, 'ref'> & RefAttributes<HTMLDivElement>
> = forwardRef((props, ref) => {
  const {
    label,
    labelSize,
    required,
    helperText,
    disabled,
    sx,
    InputProps,
    ...restProps
  } = props
  const theme = useTheme()

  return (
    <FormControl
      sx={{
        ...sx,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'stretch',
      }}
      disabled={disabled}
      fullWidth={props.fullWidth}
      ref={ref}
    >
      <KFieldLabel
        labelSize={labelSize}
        sx={{
          marginBottom: 1,
          [theme.breakpoints.down('sm')]: {
            marginBottom: 0.5,
          },
        }}
        required={required}
      >
        {label}
      </KFieldLabel>
      <OutlinedInput
        inputComponent={InputProps?.inputComponent}
        {...(restProps as any)}
        sx={{
          borderRadius: 4,
          height: 56,
          '&:hover': {
            backgroundColor: theme.palette.grey['A100'],
          },
          [theme.breakpoints.down('sm')]: {
            borderRadius: 3.5,
            height: 52,
          },
        }}
      />
      {!isEmpty(helperText) && (
        <FormHelperText
          error={props.error}
          sx={{ fontSize: theme.typography.subtitle1.fontSize }}
        >
          {helperText}
        </FormHelperText>
      )}
    </FormControl>
  )
})
